import React, { useMemo,useState,useEffect } from 'react';
import { MaterialReactTable } from 'material-react-table'
import * as api from '../../api/index';
import { CardHeader, Container, Grid } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';

export const InventoryReport = () => {

  const [data, setData] = useState(null); 
  const [startDate, setStartDate] = useState(moment().subtract(10, "days"));
  const [endDate, setEndDate] = useState(moment());;


  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  const handleRunReport = async () => {
    if (startDate !=undefined && endDate!=undefined){
        const { data } = await api.inventoryReport(moment(startDate).format("MM/DD/YYYY"),moment(endDate).format("MM/DD/YYYY")); 
    setData(data.results);
    console.log(data.results);}
  };

 
  const columns = useMemo(
    () => [

      {
        accessorKey: 'id', //access nested data with dot notation
        header: 'ID',
      },
      {
        accessorKey: 'metalName', //access nested data with dot notation
        header: 'Metal',
      },
   
      {
        accessorKey: 'weight', //normal accessorKey
        header: 'Weight',
      },
    
    ],
    [],
  );


  

  return (
    <Container style={{width: '65%', paddingBottom: '50px', border: 'none'}} >
      <Card sx={{ minWidth: 275 }}>
        <CardHeader title={"Inventory Report"}> </CardHeader>
      <CardContent>
      <Grid container >
       
       <Grid item style={{marginRight: 10}} >
                        
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                margin="normal"
                                id="date-picker-dialog"
                                label="Start date"
                                format="MM/dd/yyyy"
                                value={startDate}
                                onChange={handleStartDateChange}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                            />
                 </ MuiPickersUtilsProvider>
          </Grid>
          <Grid item style={{marginRight: 10}} >
                        
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                margin="normal"
                                id="date-picker-dialog"
                                label="End date"
                                format="MM/dd/yyyy"
                                value={endDate}
                                onChange={handleEndDateChange}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                            />
                 </ MuiPickersUtilsProvider>
          </Grid>
          <Grid>
            <Button onClick={handleRunReport} variant="contained" style={{ marginRight: '25px',marginTop:'25px' }} >
                Run Report
              </Button>
          </Grid>
          </Grid>
      </CardContent>
     
    </Card>
     
    { data!==null && ( 
    <Card sx={{ minWidth: 275 }}>
      <CardContent>
          <MaterialReactTable
            columns={columns}
            data={data}
            enableColumnActions={false}
            enableColumnFilters={false}
            enablePagination={true}
            enableSorting={true}
            enableBottomToolbar={false}
            enableTopToolbar={true}
            muiTableBodyRowProps={{ hover: false }}
          />
    </CardContent>
    </Card>
    )}
    </Container>
   );
  };
  
  export default InventoryReport;